import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.messageHistoryDetail.loading;
export const selectErrorMessage = (state: RootState) =>
  state.messageHistoryDetail.error;
export const messageHistoryDetailResponse = (state: RootState) =>
  state.messageHistoryDetail.messageHistoryDetailResponse;
